// extracted by mini-css-extract-plugin
export default {"loader_title":"Loader_loader_title__n2ED1","loading_wrapper":"Loader_loading_wrapper__cc+7Z","loader_dot":"Loader_loader_dot__yoi6X"};